import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { getRemoHosts } from "config";
import { useI18n } from "i18n";
import { selectBrandName } from "modules/settings/redux/selectors";
import { useSelector } from "react-redux";
import { styles } from "./styles";

interface Props {
  title?: string;
  subtitle?: string;
  text?: string;
}

export const AuthTopBlock = (props: Props) => {
  const { t } = useI18n();
  const isRemoDomain = getRemoHosts().includes(window.location.host);
  const brandName = useSelector(selectBrandName);
  const { title, subtitle, text } = props;

  const showSubtitle = subtitle && isRemoDomain;

  return (
    <Box sx={styles.root}>
      <Typography
        variant="h2"
        color="textPrimary"
        sx={styles.title}
        gutterBottom={!showSubtitle}
      >
        {title ||
          (isRemoDomain
            ? t("auth:login.events.virtual")
            : t("auth:login.custom.domain", {
                companyName: brandName,
              }))}
        {showSubtitle && (
          <Typography color="textPrimary" variant="h4">
            {subtitle}
          </Typography>
        )}
      </Typography>

      {text && <Typography sx={styles.text}>{text}</Typography>}
    </Box>
  );
};
